$(document).ready(function () {
  if($('select').length) {
    var initalWindowWidth = $(window).width();

    initSelect();

    $(window).on('resize', function () {
      if ($(window).width() > initalWindowWidth) {
        initSelect();
        initalWindowWidth = $(window).width();
      }
    });
  }
});

function initSelect() {
  var options = {
    create: false,
    onFocus: eventHandler('onFocus'),
    onBlur: eventHandler('onBlur'),
    onChange: eventHandler('onChange')
  };
  var $selectsList = $("select").not(".no-selectize");

  if ($(window).width() >= breakpoints.small) {
    $selectsList.selectize(options);
  }
  if ($(window).width() < breakpoints.small) {
    $selectsList.addClass("mobile-select-view");
  } else {
    $selectsList.removeClass("mobile-select-view");
  }
}

var eventHandler = function (name) {
  return function () {
    $selectBox = $($(this)[0].$input["0"]);
    $selectElement = $selectBox.closest('.select-element');

    if (name == 'onFocus') {
      $selectElement.addClass('entered active');
    } else if (name == 'onBlur') {
      if (!$selectBox.val()) {
        $selectElement.removeClass('entered active');
      } else {
        $selectElement.removeClass('active');
      }
    }

    if (name == 'onChange') {
      $selectElement.addClass('entered');
    }
  };
};